import { Component, Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { successDialogModel } from 'src/app/core/_models/confirm-dialog.model';

@Injectable()
@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss']
})
export class SuccessDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: successDialogModel) { }

}
